import { ChainData, Token } from "@0xsquid/squid-types";
import { useMemo } from "react";
import { CHAIN_IDS, nativeEvmTokenAddress } from "../../core/constants";
import { useEvmNativeBalance } from "../tokens/useNativeBalance";

interface Params {
  address: string | undefined;
  token: Token | undefined;
  chain: ChainData | undefined;
}

export function useHederaAccountActivation({ address, chain, token }: Params): {
  isHederaAccountActivated: boolean;
} {
  const { balance: destNativeEvmBalance } = useEvmNativeBalance({
    chain,
    address,
  });

  const isHederaAccountActivated = useMemo(() => {
    if (token?.chainId !== CHAIN_IDS.HEDERA) return true;
    if (token.address.toLowerCase() === nativeEvmTokenAddress.toLowerCase())
      return true;

    return (
      !!destNativeEvmBalance?.value && destNativeEvmBalance.value > BigInt(0)
    );
  }, [token?.chainId, token?.address, destNativeEvmBalance?.value]);

  return {
    isHederaAccountActivated,
  };
}
